export default __webpack_public_path__ + "static/media/down-arrow.8e384430.svg";